import { launchSuiteHelpPane } from "owa-suitehelp-utils";

export function mailHelpPaneRouteHandler(): void {
    launchSuiteHelpPane();
}
